module.exports = __webpack_public_path__ + "img/emoji_108.920ebc92.png";